window.locales = window.locales || {};window.locales.am = window.locales.am || {};window.locales.am.statusBox = window.locales.am.statusBox || {};window.locales.am.statusBox = {...window.locales.am.statusBox, ...{
    "status": "ሁኔታ",
    "startDate": "የመጀመሪያ ቀን",
    "welcomeTo": "እንኳን ደህና መጡ",
    "welcomeToThe": "እንኳን ደህና መጡ ወደ",
    "week0Title": "{startDate}",
    "week1Title": "እንኳን ደህና መጡ",
    "onTrack": "በትክክለኛ መንገድ",
    "notOnTrack": "ከመንገዱ ውጭ",
    "almostThere": "ማለት ነው!",
    "failed": "ብልሽተት",
    "graduated": "ተመርቋል",
    "preGraduationFinished": "ጨርሷል",
    "missingGraduationRequirements": "የመመረቂያ መስፈርቶች ይጎድላሉ",
    "withdrawnOrExpelled": "ተሰሪዟል ወይም ተባርሯል",
    "academicProbation": "የአካዳሚ ፈተና ወቅት",
    "checkScheduleMessage": "የዚህ ሳምንት ተግባሮች ከዚህ በታች ባለው መርሃ ግብር ይመልከቱ።",
    "goodWorkMessage": "ጥሩ ስራውን ቀጥል!",
    "week0Message": "የፕሮግራሙን መርሃ ግብር ለማየት እና ምናልባትም በኮርሶች ላይ ቀድመው ለመጀመር አሁን ጥሩ ጊዜ ነው። በSlack ላይ መመዝገብን አይዘንጉ!",
    "week0MessageNoSlack": "የፕሮግራሙን መርሃ ግብር ለማየት እና ምናልባትም በኮርሶች ላይ ቀድመው ለመጀመር አሁን ጥሩ ጊዜ ነው።",
    "week1Message": "የእርስዎን የስርዓተ ትምህርት ሁኔታ እና ተግባሮች ለማየት በየሳምንቱ እዚህ ተመለሱ።",
    "graduatedMessage": "ጥሩ ስራውን ቀጥል!",
    "preGraduationFinishedMessage": "ጥሩ ስራውን ቀጥል!",
    "failedMessage": "በሚያሳዝን ሁኔታ የመመረቂያ መስፈርቶችን አላሟሉም። የኮርስ ቤተ መጽሃፍት መዳረሻ ይይዛሉ። ለተጨማሪ መረጃ በ{supportEmail} ያነጋግሩን።",
    "academicProbationMessage": "የፈተና ሁኔታዎን ለማጽዳት እቅድ ለመነጋገር ወይም ቀጠሮ ለመያዝ {academicAdvisingEmail} ያነጋግሩ {advisingScheduleLink}።",
    "academicProbationContactMessage": "የፈተና ሁኔታዎን ለማጽዳት እቅድ ለመነጋገር ወይም ቀጠሮ ለመያዝ {academicAdvisingEmail} ያነጋግሩ {advisingScheduleLink}።",
    "completeCoursesMessage": "የሚከተሉትን ኮርሶች ፈጽሙ:",
    "completeCoursesTitle": "የሚከተሉትን ኮርሶች ፈጽሙ:",
    "submitProjectsTitle": "የሚከተሉትን ፕሮጀክቶች ወይም አቀራረቦች ያስገቡ:",
    "showMoreCourses": "{count} ተጨማሪ ኮርሶች አሳይ",
    "showMoreProjects": "{count} ተጨማሪ ፕሮጀክቶች አሳይ",
    "showLess": "ያነሰ አሳይ",
    "mobileTitleStatusPrefix": "ሁኔታ:",
    "mobileTitleWelcomePrefix": "እንኳን ደህና መጡ ወደ",
    "mobileTitleStartDatePrefix": "የመጀመሪያ ቀን:",
    "mobilePrepareForGraduation": "ለዲግሪ ይዘጋጁ",
    "mobileCheckYourCertificate": "የእርስዎን ሰርተፊኬት ይፈትሹ",
    "finished": "ተጠናቀቀ",
    "viewDetails": "ዝርዝሮች ይመልከቱ",
    "viewFullSchedule": "ሙሉ መርሃ ግብር ይመልከቱ",
    "scheduleComingSoon": "መርሃ ግብር በቅርቡ",
    "programTitle": "{programTitle}",
    "brandNameShort": "{brandNameShort}",
    "programTitleShort": "{programTitleShort}",
    "here": "እዚህ",
    "graduationDateSubtitle": "የመመረቂያ ቀን",
    "certificateCompletionDateSubtitle": "የምስክር ወረቀት ማጠናቀቂያ ቀን",
    "certificateCompletionDeadlineSubtitle": "የምስክር ወረቀት ማጠናቀቂያ <strong>የመጨረሻ ቀን</strong>",
    "programCompletionDateSubtitle": "የፕሮግራም ማጠናቀቂያ ቀን",
    "dateToDisplay": "{dateToDisplay}",
    "graduationShowDate": "የመመረቂያ ቀን: {graduationDate}",
    "certificateShowDeadline": "የምስክር ወረቀት ማጠናቀቂያ <strong>የመጨረሻ ቀን</strong>: {completionDeadline}",
    "certificateShowDate": "የምስክር ወረቀት ማጠናቀቂያ ቀን: {graduationDate}",
    "programCompletionShowDate": "የፕሮግራም ማጠናቀቂያ ቀን: {graduationDate}",
    "certificateExtensionNotice": "ለኮርስ ይዘቱ የተራዘመ መዳረሻ ሰጥተንዎታል። ምስክር ወረቀትዎን ለማግኘት መስፈርቶች ከላይ በተጠቀሰው ቀን ውስጥ መጠናቀቅ አለባቸው።",
    "completeDiplomaCheck": "የመመረቂያ ቀንዎ እየቀረበ ነው! ሁሉንም የፕሮግራም መስፈርቶች እንዲሁም ከዚህ በታች ያሉትን የዲፕሎማ ማረጋገጫ እቃዎች እንዳጠናቀቁ ያረጋግጡ።",
    "youWillBeNotifiedWhenCertIsAvailable": "ዲጂታል ምስክር ወረቀትዎ ሲገኝ በኢሜል ማሳወቂያ ይደርስዎታል። ከዚህ በታች ያሉትን የምስክር ወረቀት ማረጋገጫ እቃዎች እንዳጠናቀቁ ያረጋግጡ።"
}
};window.locales.ar = window.locales.ar || {};window.locales.ar.statusBox = window.locales.ar.statusBox || {};window.locales.ar.statusBox = {...window.locales.ar.statusBox, ...{
    "status": "الحالة",
    "startDate": "تاريخ البدء",
    "welcomeTo": "أهلاً بك في",
    "welcomeToThe": "أهلاً بك في",
    "week0Title": "{startDate}",
    "week1Title": "أهلاً بك",
    "onTrack": "على الطريق الصحيح",
    "notOnTrack": "خارج المسار",
    "almostThere": "أوشكت على الوصول!",
    "failed": "فشل",
    "graduated": "متخرج",
    "preGraduationFinished": "منتهي",
    "missingGraduationRequirements": "متطلبات التخرج مفقودة",
    "withdrawnOrExpelled": "منسحب أو مطرود",
    "academicProbation": "فترة اختبار أكاديمية",
    "checkScheduleMessage": "تحقق من الجدول أدناه لمهام هذا الأسبوع.",
    "goodWorkMessage": "استمر في العمل الجيد!",
    "week0Message": "الآن وقت مناسب لإلقاء نظرة على جدول البرنامج وربما البدء مبكراً في الدورات. لا تنس التسجيل في Slack!",
    "week0MessageNoSlack": "الآن وقت مناسب لإلقاء نظرة على جدول البرنامج وربما البدء مبكراً في الدورات.",
    "week1Message": "ارجع هنا كل أسبوع لرؤية حالة منهجك ومهامك.",
    "graduatedMessage": "استمر في العمل الجيد!",
    "preGraduationFinishedMessage": "استمر في العمل الجيد!",
    "failedMessage": "للأسف، لم تستوف متطلبات التخرج. ستحتفظ بالوصول إلى مكتبة دوراتك. لمزيد من المعلومات، اتصل بنا على {supportEmail}.",
    "academicProbationMessage": "اتصل بـ {academicAdvisingEmail} لمناقشة خطة لإزالة حالة فترة الاختبار أو حدد موعد {advisingScheduleLink}.",
    "academicProbationContactMessage": "اتصل بـ {academicAdvisingEmail} لمناقشة خطة لإزالة حالة فترة الاختبار أو حدد موعد {advisingScheduleLink}.",
    "completeCoursesMessage": "أكمل الدورات التالية:",
    "completeCoursesTitle": "أكمل الدورات التالية:",
    "submitProjectsTitle": "قدم المشاريع أو العروض التقديمية التالية:",
    "showMoreCourses": "أظهر {count} دورات أخرى",
    "showMoreProjects": "أظهر {count} مشاريع أخرى",
    "showLess": "أظهر أقل",
    "mobileTitleStatusPrefix": "الحالة:",
    "mobileTitleWelcomePrefix": "مرحبا بك في",
    "mobileTitleStartDatePrefix": "تاريخ البدء:",
    "mobilePrepareForGraduation": "استعد للتخرج",
    "mobileCheckYourCertificate": "تحقق من شهادتك",
    "finished": "انتهى",
    "viewDetails": "عرض التفاصيل",
    "viewFullSchedule": "عرض الجدول الكامل",
    "scheduleComingSoon": "الجدول قادم قريباً",
    "programTitle": "{programTitle}",
    "brandNameShort": "{brandNameShort}",
    "programTitleShort": "{programTitleShort}",
    "here": "هنا",
    "graduationDateSubtitle": "تاريخ التخرج",
    "certificateCompletionDateSubtitle": "تاريخ إكمال الشهادة",
    "certificateCompletionDeadlineSubtitle": "<strong>موعد</strong> إكمال الشهادة النهائي",
    "programCompletionDateSubtitle": "تاريخ إكمال البرنامج",
    "dateToDisplay": "{dateToDisplay}",
    "graduationShowDate": "تاريخ التخرج: {graduationDate}",
    "certificateShowDeadline": "<strong>موعد</strong> إكمال الشهادة النهائي: {completionDeadline}",
    "certificateShowDate": "تاريخ إكمال الشهادة: {graduationDate}",
    "programCompletionShowDate": "تاريخ إكمال البرنامج: {graduationDate}",
    "certificateExtensionNotice": "لقد منحناك وصولاً ممدداً لمحتوى الدورة. يجب إكمال المتطلبات بحلول التاريخ المذكور أعلاه للحصول على شهادتك.",
    "completeDiplomaCheck": "تاريخ تخرجك قادم! تأكد من إكمال جميع متطلبات البرنامج بالإضافة إلى عناصر فحص الشهادة أدناه.",
    "youWillBeNotifiedWhenCertIsAvailable": "ستتلقى إشعاراً بالبريد الإلكتروني عندما تصبح شهادتك الرقمية متاحة. تأكد من إكمال عناصر فحص الشهادة أدناه."
}
};window.locales.en = window.locales.en || {};window.locales.en.statusBox = window.locales.en.statusBox || {};window.locales.en.statusBox = {...window.locales.en.statusBox, ...{
    "status": "Status",
    "startDate": "Start Date",
    "welcomeTo": "Welcome to",
    "welcomeToThe": "Welcome to The",
    "week0Title": "{startDate}",
    "week1Title": "Welcome",
    "onTrack": "On Track",
    "notOnTrack": "Not On Track",
    "almostThere": "Almost There!",
    "failed": "Failed",
    "graduated": "Graduated",
    "preGraduationFinished": "Finished",
    "missingGraduationRequirements": "Missing Graduation Requirements",
    "withdrawnOrExpelled": "Withdrawn or Expelled",
    "academicProbation": "Academic Probation",
    "checkScheduleMessage": "Check the schedule below for this week's assignments.",
    "goodWorkMessage": "Keep up the good work!",
    "week0Message": "Now's a good time to take a look at the program schedule and perhaps get a head start on courses. Don't forget to register on Slack!",
    "week0MessageNoSlack": "Now's a good time to take a look at the program schedule and perhaps get a head start on courses.",
    "week1Message": "Check back here each week to see your curriculum status and assignments.",
    "graduatedMessage": "Keep up the good work!",
    "preGraduationFinishedMessage": "Keep up the good work!",
    "failedMessage": "Unfortunately, you did not meet the graduation requirements. You will retain access to your course library. For more information, contact us at {supportEmail}.",
    "academicProbationMessage": "Contact {academicAdvisingEmail} to discuss a plan to clear your probationary status or schedule an appointment {advisingScheduleLink}.",
    "academicProbationContactMessage": "Contact {academicAdvisingEmail} to discuss a plan to clear your probationary status or schedule an appointment {advisingScheduleLink}.",
    "completeCoursesMessage": "Complete the following courses:",
    "completeCoursesTitle": "Complete the following courses:",
    "submitProjectsTitle": "Submit the following projects or presentations:",
    "showMoreCourses": "Show {count} more courses",
    "showMoreProjects": "Show {count} more projects",
    "showLess": "Show less",
    "mobileTitleStatusPrefix": "Status:",
    "mobileTitleWelcomePrefix": "Welcome to",
    "mobileTitleStartDatePrefix": "Start Date:",
    "mobilePrepareForGraduation": "Prepare for Graduation",
    "mobileCheckYourCertificate": "Check your Certificate",
    "finished": "Finished",
    "viewDetails": "View Details",
    "viewFullSchedule": "View Full Schedule",
    "scheduleComingSoon": "Schedule Coming Soon",
    "programTitle": "{programTitle}",
    "brandNameShort": "{brandNameShort}",
    "programTitleShort": "{programTitleShort}",
    "here": "here",
    "graduationDateSubtitle": "Graduation Date",
    "certificateCompletionDateSubtitle": "Certificate Completion Date",
    "certificateCompletionDeadlineSubtitle": "Certificate Completion <strong>Deadline</strong>",
    "programCompletionDateSubtitle": "Program Completion Date",
    "dateToDisplay": "{dateToDisplay}",
    "graduationShowDate": "Graduation Date: {graduationDate}",
    "certificateShowDeadline": "Certificate Completion <strong>Deadline</strong>: {completionDeadline}",
    "certificateShowDate": "Certificate Completion Date: {graduationDate}",
    "programCompletionShowDate": "Program Completion Date: {graduationDate}",
    "certificateExtensionNotice": "We have granted you extended access to the coursework. Requirements must be completed by the above date in order to earn your certificate.",
    "completeDiplomaCheck": "Your graduation date is coming up! Please be sure you have completed all program requirements as well as the Diploma Check items below.",
    "youWillBeNotifiedWhenCertIsAvailable": "You will receive an email notification when your digital certificate is available. Please be sure to complete the Certificate Check items below."
}
};window.locales.es = window.locales.es || {};window.locales.es.statusBox = window.locales.es.statusBox || {};window.locales.es.statusBox = {...window.locales.es.statusBox, ...{
    "status": "Estado",
    "startDate": "Fecha de Inicio",
    "welcomeTo": "Bienvenido a",
    "welcomeToThe": "Bienvenido a The",
    "week0Title": "{startDate}",
    "week1Title": "Bienvenido",
    "onTrack": "En Pista",
    "notOnTrack": "Fuera de Pista",
    "almostThere": "¡Casi Allí!",
    "failed": "Reprobado",
    "graduated": "Graduado",
    "preGraduationFinished": "Terminado",
    "missingGraduationRequirements": "Faltan Requisitos de Graduación",
    "withdrawnOrExpelled": "Retirado o Expulsado",
    "academicProbation": "Período de Prueba Académico",
    "checkScheduleMessage": "Consulta el horario a continuación para las tareas de esta semana.",
    "goodWorkMessage": "¡Sigue con el buen trabajo!",
    "week0Message": "Ahora es un buen momento para echar un vistazo al horario del programa y quizás adelantarte con los cursos. ¡No olvides registrarte en Slack!",
    "week0MessageNoSlack": "Ahora es un buen momento para echar un vistazo al horario del programa y quizás adelantarte con los cursos.",
    "week1Message": "Vuelve aquí cada semana para ver tu estado curricular y tareas.",
    "graduatedMessage": "¡Sigue con el buen trabajo!",
    "preGraduationFinishedMessage": "¡Sigue con el buen trabajo!",
    "failedMessage": "Desafortunadamente, no cumpliste con los requisitos de graduación. Mantendrás acceso a tu biblioteca de cursos. Para más información, contáctanos en {supportEmail}.",
    "academicProbationMessage": "Contacta a {academicAdvisingEmail} para discutir un plan para aclarar tu estado de período de prueba o programa una cita {advisingScheduleLink}.",
    "academicProbationContactMessage": "Contacta a {academicAdvisingEmail} para discutir un plan para aclarar tu estado de período de prueba o programa una cita {advisingScheduleLink}.",
    "completeCoursesMessage": "Completa los siguientes cursos:",
    "completeCoursesTitle": "Completa los siguientes cursos:",
    "submitProjectsTitle": "Envía los siguientes proyectos o presentaciones:",
    "showMoreCourses": "Mostrar {count} cursos más",
    "showMoreProjects": "Mostrar {count} proyectos más",
    "showLess": "Mostrar menos",
    "mobileTitleStatusPrefix": "Estado:",
    "mobileTitleWelcomePrefix": "Bienvenido a",
    "mobileTitleStartDatePrefix": "Fecha de Inicio:",
    "mobilePrepareForGraduation": "Prepárate para la Graduación",
    "mobileCheckYourCertificate": "Verifica tu Certificado",
    "finished": "Terminado",
    "viewDetails": "Ver Detalles",
    "viewFullSchedule": "Ver Horario Completo",
    "scheduleComingSoon": "Horario Próximamente",
    "programTitle": "{programTitle}",
    "brandNameShort": "{brandNameShort}",
    "programTitleShort": "{programTitleShort}",
    "here": "aquí",
    "graduationDateSubtitle": "Fecha de Graduación",
    "certificateCompletionDateSubtitle": "Fecha de Finalización del Certificado",
    "certificateCompletionDeadlineSubtitle": "<strong>Fecha Límite</strong> de Finalización del Certificado",
    "programCompletionDateSubtitle": "Fecha de Finalización del Programa",
    "dateToDisplay": "{dateToDisplay}",
    "graduationShowDate": "Fecha de Graduación: {graduationDate}",
    "certificateShowDeadline": "<strong>Fecha Límite</strong> de Finalización del Certificado: {completionDeadline}",
    "certificateShowDate": "Fecha de Finalización del Certificado: {graduationDate}",
    "programCompletionShowDate": "Fecha de Finalización del Programa: {graduationDate}",
    "certificateExtensionNotice": "Te hemos otorgado acceso extendido al material del curso. Los requisitos deben completarse antes de la fecha indicada para obtener tu certificado.",
    "completeDiplomaCheck": "¡Tu fecha de graduación se acerca! Asegúrate de haber completado todos los requisitos del programa así como los elementos de Verificación de Diploma a continuación.",
    "youWillBeNotifiedWhenCertIsAvailable": "Recibirás una notificación por correo electrónico cuando tu certificado digital esté disponible. Asegúrate de completar los elementos de Verificación de Certificado a continuación."
}
};window.locales.it = window.locales.it || {};window.locales.it.statusBox = window.locales.it.statusBox || {};window.locales.it.statusBox = {...window.locales.it.statusBox, ...{
    "status": "Stato",
    "startDate": "Data di Inizio",
    "welcomeTo": "Benvenuto a",
    "welcomeToThe": "Benvenuto a The",
    "week0Title": "{startDate}",
    "week1Title": "Benvenuto",
    "onTrack": "In Regola",
    "notOnTrack": "Non in Regola",
    "almostThere": "Quasi Arrivato!",
    "failed": "Fallito",
    "graduated": "Laureato",
    "preGraduationFinished": "Finito",
    "missingGraduationRequirements": "Requisiti di Laurea Mancanti",
    "withdrawnOrExpelled": "Ritirato o Espulso",
    "academicProbation": "Periodo di Prova Accademico",
    "checkScheduleMessage": "Controlla il programma qui sotto per i compiti di questa settimana.",
    "goodWorkMessage": "Continua così!",
    "week0Message": "Questo è un buon momento per dare un'occhiata al programma del corso e magari iniziare in anticipo con i corsi. Non dimenticare di registrarti su Slack!",
    "week0MessageNoSlack": "Questo è un buon momento per dare un'occhiata al programma del corso e magari iniziare in anticipo con i corsi.",
    "week1Message": "Torna qui ogni settimana per vedere il tuo stato curriculare e i compiti.",
    "graduatedMessage": "Continua così!",
    "preGraduationFinishedMessage": "Continua così!",
    "failedMessage": "Sfortunatamente, non hai soddisfatto i requisiti di laurea. Manterrai l'accesso alla tua libreria di corsi. Per maggiori informazioni, contattaci all'indirizzo {supportEmail}.",
    "academicProbationMessage": "Contatta {academicAdvisingEmail} per discutere un piano per chiarire il tuo stato di periodo di prova o programma un appuntamento {advisingScheduleLink}.",
    "academicProbationContactMessage": "Contatta {academicAdvisingEmail} per discutere un piano per chiarire il tuo stato di periodo di prova o programma un appuntamento {advisingScheduleLink}.",
    "completeCoursesMessage": "Completa i seguenti corsi:",
    "completeCoursesTitle": "Completa i seguenti corsi:",
    "submitProjectsTitle": "Invia i seguenti progetti o presentazioni:",
    "showMoreCourses": "Mostra altri {count} corsi",
    "showMoreProjects": "Mostra altri {count} progetti",
    "showLess": "Mostra meno",
    "mobileTitleStatusPrefix": "Stato:",
    "mobileTitleWelcomePrefix": "Benvenuto a",
    "mobileTitleStartDatePrefix": "Data di Inizio:",
    "mobilePrepareForGraduation": "Preparati per la Laurea",
    "mobileCheckYourCertificate": "Controlla il tuo Certificato",
    "finished": "Finito",
    "viewDetails": "Visualizza Dettagli",
    "viewFullSchedule": "Visualizza Programma Completo",
    "scheduleComingSoon": "Programma in Arrivo",
    "programTitle": "{programTitle}",
    "brandNameShort": "{brandNameShort}",
    "programTitleShort": "{programTitleShort}",
    "here": "qui",
    "graduationDateSubtitle": "Data di Laurea",
    "certificateCompletionDateSubtitle": "Data di Completamento Certificato",
    "certificateCompletionDeadlineSubtitle": "<strong>Scadenza</strong> Completamento Certificato",
    "programCompletionDateSubtitle": "Data di Completamento Programma",
    "dateToDisplay": "{dateToDisplay}",
    "graduationShowDate": "Data di Laurea: {graduationDate}",
    "certificateShowDeadline": "<strong>Scadenza</strong> Completamento Certificato: {completionDeadline}",
    "certificateShowDate": "Data di Completamento Certificato: {graduationDate}",
    "programCompletionShowDate": "Data di Completamento Programma: {graduationDate}",
    "certificateExtensionNotice": "Ti abbiamo concesso accesso esteso al materiale del corso. I requisiti devono essere completati entro la data sopra indicata per ottenere il tuo certificato.",
    "completeDiplomaCheck": "La tua data di laurea si sta avvicinando! Assicurati di aver completato tutti i requisiti del programma così come gli elementi di Controllo Diploma qui sotto.",
    "youWillBeNotifiedWhenCertIsAvailable": "Riceverai una notifica email quando il tuo certificato digitale sarà disponibile. Assicurati di completare gli elementi di Controllo Certificato qui sotto."
}
};window.locales.zh = window.locales.zh || {};window.locales.zh.statusBox = window.locales.zh.statusBox || {};window.locales.zh.statusBox = {...window.locales.zh.statusBox, ...{
    "status": "状态",
    "startDate": "开始日期",
    "welcomeTo": "欢迎来到",
    "welcomeToThe": "欢迎来到",
    "week0Title": "{startDate}",
    "week1Title": "欢迎",
    "onTrack": "正常进行",
    "notOnTrack": "进度落后",
    "almostThere": "即将完成！",
    "failed": "失败",
    "graduated": "已毕业",
    "preGraduationFinished": "已完成",
    "missingGraduationRequirements": "缺少毕业要求",
    "withdrawnOrExpelled": "退学或被开除",
    "academicProbation": "学术试读",
    "checkScheduleMessage": "查看下面的时间表了解本周的作业。",
    "goodWorkMessage": "继续保持！",
    "week0Message": "现在是查看项目时间表和提前开始课程的好时机。别忘了在Slack上注册！",
    "week0MessageNoSlack": "现在是查看项目时间表和提前开始课程的好时机。",
    "week1Message": "每周回到这里查看你的课程状态和作业。",
    "graduatedMessage": "继续保持！",
    "preGraduationFinishedMessage": "继续保持！",
    "failedMessage": "很遗憾，您没有满足毕业要求。您将保留对课程库的访问权限。如需更多信息，请通过{supportEmail}联系我们。",
    "academicProbationMessage": "请联系{academicAdvisingEmail}讨论清除试读状态的计划或预约{advisingScheduleLink}。",
    "academicProbationContactMessage": "请联系{academicAdvisingEmail}讨论清除试读状态的计划或预约{advisingScheduleLink}。",
    "completeCoursesMessage": "完成以下课程：",
    "completeCoursesTitle": "完成以下课程：",
    "submitProjectsTitle": "提交以下项目或演示：",
    "showMoreCourses": "显示更多{count}门课程",
    "showMoreProjects": "显示更多{count}个项目",
    "showLess": "显示更少",
    "mobileTitleStatusPrefix": "状态:",
    "mobileTitleWelcomePrefix": "欢迎来到",
    "mobileTitleStartDatePrefix": "开始日期:",
    "mobilePrepareForGraduation": "准备毕业",
    "mobileCheckYourCertificate": "检查您的证书",
    "finished": "已完成",
    "viewDetails": "查看详情",
    "viewFullSchedule": "查看完整时间表",
    "scheduleComingSoon": "时间表即将发布",
    "programTitle": "{programTitle}",
    "brandNameShort": "{brandNameShort}",
    "programTitleShort": "{programTitleShort}",
    "here": "这里",
    "graduationDateSubtitle": "毕业日期",
    "certificateCompletionDateSubtitle": "证书完成日期",
    "certificateCompletionDeadlineSubtitle": "证书完成<strong>截止日期</strong>",
    "programCompletionDateSubtitle": "项目完成日期",
    "dateToDisplay": "{dateToDisplay}",
    "graduationShowDate": "毕业日期：{graduationDate}",
    "certificateShowDeadline": "证书完成<strong>截止日期</strong>：{completionDeadline}",
    "certificateShowDate": "证书完成日期：{graduationDate}",
    "programCompletionShowDate": "项目完成日期：{graduationDate}",
    "certificateExtensionNotice": "我们已为您延长了课程访问权限。必须在上述日期之前完成要求才能获得证书。",
    "completeDiplomaCheck": "您的毕业日期即将到来！请确保您已完成所有项目要求以及下面的文凭检查项目。",
    "youWillBeNotifiedWhenCertIsAvailable": "您的数字证书可用时，您将收到电子邮件通知。请确保完成下面的证书检查项目。"
}
};